import {
  type QuestionInputData,
  type GetQuestionGroupByIdQuery,
  useSaveQuestionAsDraftMutation,
  useSaveQuestionAsUnpublishedMutation,
  QuestionGroupStatus,
  type SaveQuestionAsDraftMutationOptions,
  type SaveQuestionAsUnpublishedMutationOptions,
} from '@exam-management/graphql';

type ItemSet = GetQuestionGroupByIdQuery['qctGetQuestionGroupById'];

interface ItemSetSubQuestionEditFormLogicProps {
  itemSet: ItemSet;
}

interface SaveSubQuestionInput {
  id: string;
  qBankStructureLevelItemId: string;
  data: QuestionInputData;
}

type SaveSubQuestionOptions =
  | SaveQuestionAsDraftMutationOptions
  | SaveQuestionAsUnpublishedMutationOptions
  | undefined;

export default function useItemSetSubQuestionEditFormLogic(
  props: Readonly<ItemSetSubQuestionEditFormLogicProps>,
) {
  const {
    itemSet: { status },
  } = props;

  const [saveQuestionAsDraft] = useSaveQuestionAsDraftMutation();
  const [saveQuestionAsUnpublished] = useSaveQuestionAsUnpublishedMutation();

  const saveSubQuestion = async (
    input: SaveSubQuestionInput,
    options: SaveSubQuestionOptions | undefined = {},
  ) => {
    const { id, qBankStructureLevelItemId, data: subQuestionData } = input;

    switch (status) {
      case QuestionGroupStatus.Draft:
      case QuestionGroupStatus.PreDraft:
        return await saveQuestionAsDraft({
          variables: {
            input: {
              id,
              qBankStructureLevelItemId,
              data: subQuestionData,
            },
          },
          ...(options as SaveQuestionAsDraftMutationOptions),
        });
      case QuestionGroupStatus.Unpublished:
        return await saveQuestionAsUnpublished({
          variables: {
            input: {
              id,
              data: subQuestionData,
            },
          },
          ...(options as SaveQuestionAsUnpublishedMutationOptions),
        });
      default:
        console.error('Invalid status', status);
    }
  };

  return { saveSubQuestion };
}
